const REFERENCE_ASSETS = require('../reference-assets.js');

module.exports = {
    dai: {
        id: 'dai',
        type: REFERENCE_ASSETS.USD,
        symbol: 'DAI',
        coingeckoId: 'dai',
        decimals: 1e18,
        address: '0x6b175474e89094c44da98b954eedeac495271d0f',
    },
    cdai: {
        id: 'cdai',
        type: REFERENCE_ASSETS.USD,
        symbol: 'cDAI',
        decimals: 1e8,
        address: '0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643',
        wrappedCoinType: 'compound',
    },
    ydai: {
        id: 'ydai',
        type: REFERENCE_ASSETS.USD,
        symbol: 'yDAI',
        decimals: 1e18,
        address: '0x16de59092dae5ccf4a1e6439d611fd0653f0bd01',
        wrappedCoinType: 'iearn',
    },
    adai: {
        id: 'adai',
        type: REFERENCE_ASSETS.USD,
        symbol: 'aDAI',
        decimals: 1e18,
        address: '0x028171bCA77440897B824Ca71D1c56caC55b68A3',
        wrappedCoinType: 'aave',
    },
    ycdai: {
        id: 'ycdai',
        type: REFERENCE_ASSETS.USD,
        symbol: 'ycDAI',
        decimals: 1e18,
        address: '0x99d1Fa417f94dcD62BfE781a1213c092a47041Bc',
        wrappedCoinType: 'iearn-fork',
    },
    cydai: {
        id: 'cydai',
        type: REFERENCE_ASSETS.USD,
        symbol: 'cyDAI',
        decimals: 1e8,
        address: '0x8e595470Ed749b85C6F7669de83EAe304C2ec68F',
        wrappedCoinType: 'iearn-cream',
    },
    usdc: {
        id: 'usdc',
        coingeckoId: 'usd-coin',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDC',
        decimals: 1e6,
        address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
    },
    cusdc: {
        id: 'cusdc',
        type: REFERENCE_ASSETS.USD,
        symbol: 'cUSDC',
        decimals: 1e8,
        address: '0x39aa39c021dfbae8fac545936693ac917d5e7563',
        wrappedCoinType: 'compound',
    },
    yusdc: {
        id: 'yusdc',
        type: REFERENCE_ASSETS.USD,
        symbol: 'yUSDC',
        decimals: 1e6,
        address: '0xd6ad7a6750a7593e092a9b218d66c0a814a3436e',
        wrappedCoinType: 'iearn',
    },
    ausdc: {
        id: 'ausdc',
        type: REFERENCE_ASSETS.USD,
        symbol: 'aUSDC',
        decimals: 1e6,
        address: '0xBcca60bB61934080951369a648Fb03DF4F96263C',
        wrappedCoinType: 'aave',
    },
    ycusdc: {
        id: 'ycusdc',
        type: REFERENCE_ASSETS.USD,
        symbol: 'ycUSDC',
        decimals: 1e6,
        address: '0x9777d7E2b60bB01759D0E2f8be2095df444cb07E',
        wrappedCoinType: 'iearn-fork',
    },
    cyusdc: {
        id: 'cyusdc',
        type: REFERENCE_ASSETS.USD,
        symbol: 'cyUSDC',
        decimals: 1e8,
        address: '0x76Eb2FE28b36B3ee97F3Adae0C69606eeDB2A37c',
        wrappedCoinType: 'iearn-cream',
    },
    usdt: {
        id: 'usdt',
        coingeckoId: 'tether',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDT',
        decimals: 1e6,
        address: '0xdac17f958d2ee523a2206206994597c13d831ec7',
    },
    yusdt: {
        id: 'yusdt',
        type: REFERENCE_ASSETS.USD,
        symbol: 'yUSDT',
        decimals: 1e6,
        address: '0x83f798e925bcd4017eb265844fddabb448f1707d',
        wrappedCoinType: 'iearn',
    },
    ausdt: {
        id: 'ausdt',
        type: REFERENCE_ASSETS.USD,
        symbol: 'aUSDT',
        decimals: 1e6,
        address: '0x3Ed3B47Dd13EC9a98b44e6204A523E766B225811',
        wrappedCoinType: 'aave',
    },
    ycusdt: {
        id: 'ycusdt',
        type: REFERENCE_ASSETS.USD,
        symbol: 'ycUSDT',
        decimals: 1e6,
        address: '0x1bE5d71F2dA660BFdee8012dDc58D024448A0A59',
        wrappedCoinType: 'iearn-fork',
    },
    cyusdt: {
        id: 'cyusdt',
        type: REFERENCE_ASSETS.USD,
        symbol: 'cyUSDT',
        decimals: 1e8,
        address: '0x48759F220ED983dB51fA7A8C0D2AAb8f3ce4166a',
        wrappedCoinType: 'iearn-cream',
    },
    tusd: {
        id: 'tusd',
        type: REFERENCE_ASSETS.USD,
        symbol: 'TUSD',
        decimals: 1e18,
        address: '0x0000000000085d4780B73119b644AE5ecd22b376',
    },
    ytusd: {
        id: 'ytusd',
        type: REFERENCE_ASSETS.USD,
        symbol: 'yTUSD',
        decimals: 1e18,
        address: '0x73a052500105205d34daf004eab301916da8190f',
        wrappedCoinType: 'iearn',
    },
    busd: {
        id: 'busd',
        type: REFERENCE_ASSETS.USD,
        symbol: 'BUSD',
        decimals: 1e18,
        address: '0x4Fabb145d64652a948d72533023f6E7A623C7C53',
    },
    ybusd: {
        id: 'ybusd',
        type: REFERENCE_ASSETS.USD,
        symbol: 'yBUSD',
        decimals: 1e18,
        address: '0x04bC0Ab673d88aE9dbC9DA2380cB6B79C4BCa9aE',
        wrappedCoinType: 'iearn',
    },
    susd: {
        id: 'susd',
        type: REFERENCE_ASSETS.USD,
        symbol: 'sUSD',
        decimals: 1e18,
        address: '0x57ab1ec28d129707052df4df418d58a2d46d5f51',
        isSynth: true,
    },
    asusd: {
        id: 'asusd',
        type: REFERENCE_ASSETS.USD,
        symbol: 'aSUSD',
        decimals: 1e18,
        address: '0x6C5024Cd4F8A59110119C56f8933403A539555EB',
        wrappedCoinType: 'aave',
    },
    pax: {
        id: 'pax',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDPAX',
        decimals: 1e18,
        address: '0x8E870D67F660D95d5be530380D0eC0bd388289E1',
    },
    renbtc: {
        id: 'renbtc',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'renBTC',
        decimals: 1e8,
        address: '0xeb4c2781e4eba804ce9a9803c67d0893436bb27d',
    },
    wbtc: {
        id: 'wbtc',
        coingeckoId: 'wrapped-bitcoin',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'wBTC',
        decimals: 1e8,
        address: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
    },
    sbtc: {
        id: 'sbtc',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'sBTC',
        decimals: 1e18,
        address: '0xfe18be6b3bd88a2d2a7f928d00292e7a9963cfc6',
        isSynth: true,
    },
    hbtc: {
        id: 'hbtc',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'HBTC',
        decimals: 1e18,
        address: '0x0316EB71485b0Ab14103307bf65a021042c6d380',
    },
    gusd: {
        id: 'gusd',
        type: REFERENCE_ASSETS.USD,
        symbol: 'GUSD',
        decimals: 1e2,
        address: '0x056fd409e1d7a124bd7017459dfea2f387b6d5cd',
    },
    husd: {
        id: 'husd',
        type: REFERENCE_ASSETS.USD,
        symbol: 'HUSD',
        decimals: 1e8,
        address: '0xdf574c24545e5ffecb9a659c229253d4111d87e1',
    },
    usdk: {
        id: 'usdk',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDK',
        decimals: 1e18,
        address: '0x1c48f86ae57291f7686349f12601910bd8d470bb',
    },
    usdn: {
        id: 'usdn',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDN',
        decimals: 1e18,
        address: '0x674C6Ad92Fd080e4004b2312b45f796a192D27a0',
    },
    linkusd: {
        id: 'linkusd',
        type: REFERENCE_ASSETS.USD,
        symbol: 'LINKUSD',
        decimals: 1e18,
        address: '0x0E2EC54fC0B509F445631Bf4b91AB8168230C752',
    },
    musd: {
        id: 'musd',
        type: REFERENCE_ASSETS.USD,
        symbol: 'mUSD',
        decimals: 1e18,
        address: '0xe2f2a5c287993345a840db3b0845fbc70f5935a5',
    },
    usd: {
        id: 'usd',
        coingeckoId: 'dollar',
        isTradable: false,
    },
    btc: {
        id: 'usd',
        coingeckoId: 'wrapped-bitcoin',
        isTradable: false,
    },
    rsv: {
        id: 'rsv',
        type: REFERENCE_ASSETS.USD,
        symbol: 'RSV',
        decimals: 1e18,
        address: '0x196f4727526eA7FB1e17b2071B3d8eAA38486988',
    },
    tbtc: {
        id: 'tbtc',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'tBTC',
        decimals: 1e18,
        address: '0x8dAEBADE922dF735c38C80C7eBD708Af50815fAa',
    },
    dusd: {
        id: 'dusd',
        type: REFERENCE_ASSETS.USD,
        symbol: 'DUSD',
        decimals: 1e18,
        address: '0x5bc25f649fc4e26069ddf4cf4010f9f706c23831',
    },
    pbtc: {
        id: 'pbtc',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'pBTC',
        decimals: 1e18,
        address: '0x5228a22e72ccc52d415ecfd199f99d0665e7733b',
    },
    bbtc: {
        id: 'bbtc',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'BBTC',
        decimals: 1e8,
        address: '0x9be89d2a4cd102d8fecc6bf9da793be995c22541',
    },
    obtc: {
        id: 'obtc',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'oBTC',
        decimals: 1e18,
        address: '0x8064d9Ae6cDf087b1bcd5BDf3531bD5d8C537a68',
    },
    ust: {
        id: 'ust',
        type: REFERENCE_ASSETS.USD,
        symbol: 'UST',
        decimals: 1e18,
        address: '0xa47c8bf37f92abed4a126bda807a7b7498661acd',
    },
    eurs: {
        id: 'eurs',
        type: REFERENCE_ASSETS.EUR,
        symbol: 'EURs',
        coingeckoId: 'stasis-eurs',
        decimals: 1e2,
        address: '0xdb25f211ab05b1c97d595516f45794528a807ad8',
        check_market: true, // ?
    },
    seur: {
        id: 'seur',
        type: REFERENCE_ASSETS.EUR,
        symbol: 'sEUR',
        decimals: 1e18,
        address: '0xd71ecff9342a5ced620049e616c5035f1db98620',
        isSynth: true,
        check_market: true, // ?
    },
    eth: {
        id: 'eth',
        type: REFERENCE_ASSETS.ETH,
        symbol: 'ETH',
        decimals: 1e18,
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    },
    seth: {
        id: 'seth',
        type: REFERENCE_ASSETS.ETH,
        symbol: 'sETH',
        decimals: 1e18,
        address: '0x5e74c9036fb86bd7ecdcb084a0673efc32ea31cb',
        isSynth: true,
    },
    frxeth: {
        id: 'frxeth',
        type: REFERENCE_ASSETS.ETH,
        symbol: 'frxETH',
        decimals: 1e18,
        address: '0x5E8422345238F34275888049021821E8E08CAa1f',
    },
    steth: {
        id: 'steth',
        type: REFERENCE_ASSETS.ETH,
        symbol: 'stETH',
        decimals: 1e18,
        address: '0xae7ab96520de3a18e5e111b5eaab095312d7fe84',
    },
    ankreth: {
        id: 'ankreth',
        type: REFERENCE_ASSETS.ETH,
        symbol: 'ankrETH',
        decimals: 1e18,
        address: '0xe95a203b1a91a908f9b9ce46459d101078c2c3cb',
    },
    usdp: {
        id: 'usdp',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDP',
        decimals: 1e18,
        address: '0x1456688345527bE1f37E9e627DA0837D6f08C925',
    },
    link: {
        id: 'link',
        type: REFERENCE_ASSETS.LINK,
        symbol: 'LINK',
        decimals: 1e18,
        address: '0x514910771af9ca656af840dff83e8264ecf986ca',
    },
    slink: {
        id: 'slink',
        type: REFERENCE_ASSETS.LINK,
        symbol: 'sLINK',
        decimals: 1e18,
        address: '0xbbc455cb4f1b9e4bfc4b73970d360c8f032efee6',
        isSynth: true,
    },
    tricrv: {
        id: 'tricrv',
        coingeckoId: 'lp-3pool-curve',
        type: REFERENCE_ASSETS.USD,
        symbol: '3Crv',
        decimals: 1e18,
        address: '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
        isLpToken: true,
    },
    sbtccrv: {
        id: 'sbtccrv',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'sbtcCrv',
        decimals: 1e18,
        address: '0x075b1bb99792c9E1041bA13afEf80C91a1e70fB3',
        isLpToken: true,
    },
    frax: {
        id: 'frax',
        type: REFERENCE_ASSETS.USD,
        symbol: 'FRAX',
        decimals: 1e18,
        address: '0x853d955acef822db058eb8505911ed77f175b99e',
    },
    lusd: {
        id: 'lusd',
        type: REFERENCE_ASSETS.USD,
        symbol: 'LUSD',
        decimals: 1e18,
        address: '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
    },
    reth: {
        id: 'reth',
        type: REFERENCE_ASSETS.ETH,
        symbol: 'stafi-rETH',
        decimals: 1e18,
        address: '0x9559aaa82d9649c7a7b220e7c461d2e74c9a3593'
    },
    alusd: {
        id: 'alusd',
        type: REFERENCE_ASSETS.USD,
        symbol: 'alUSD',
        decimals: 1e18,
        address: '0xbc6da0fe9ad5f3b0d58160288917aa56653660e9'
    },
    weth: {
        id: 'weth',
        type: REFERENCE_ASSETS.ETH,
        symbol: 'WETH',
        decimals: 1e18,
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
        coingeckoId: 'weth',
    },
    mim: {
        id: 'mim',
        type: REFERENCE_ASSETS.USD,
        symbol: 'MIM',
        decimals: 1e18,
        address: '0x99d8a9c45b2eca8864373a26d1459e3dff1e17f3',
    },
    crv: {
        id: 'crv',
        coingeckoId: 'curve-dao-token',
        type: REFERENCE_ASSETS.CRV,
        symbol: 'CRV',
        decimals: 1e18,
        address: '0xd533a949740bb3306d119cc777fa900ba034cd52',
    },
    eurt: {
        id: 'eurt',
        coingeckoId: 'tether-eurt',
        type: REFERENCE_ASSETS.EUR,
        symbol: 'EURT',
        decimals: 1e6,
        address: '0xC581b735A1688071A1746c968e0798D642EDE491',
    },
    euroc: {
        id: 'euroc',
        coingeckoId: 'euro-coin',
        type: REFERENCE_ASSETS.EUR,
        symbol: 'EUROC',
        decimals: 1e6,
        address: '0x1abaea1f7c830bd89acc67ec4af516284b1bc33c',
    },
    rai: {
        id: 'rai',
        coingeckoId: 'rai',
        type: REFERENCE_ASSETS.OTHER,
        symbol: 'RAI',
        decimals: 1e18,
        address: '0x03ab458634910aad20ef5f1c8ee96f1d6ac54919',
    },
    cvx: {
        id: 'cvx',
        coingeckoId: 'convex-finance',
        type: REFERENCE_ASSETS.CVX,
        symbol: 'CVX',
        decimals: 1e18,
        address: '0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b',
    },
    xaut: {
        id: 'xaut',
        coingeckoId: 'tether-gold',
        type: REFERENCE_ASSETS.GOLD,
        symbol: 'XAUt',
        decimals: 1e6,
        address: '0x68749665ff8d2d112fa859aa293f07a622782f38',
    },
    spell: {
        id: 'spell',
        coingeckoId: 'spell-token',
        type: REFERENCE_ASSETS.SPELL,
        symbol: 'SPELL',
        decimals: 1e18,
        address: '0x090185f2135308bad17527004364ebcc2d37e5f6',
    },
    t: {
        id: 't',
        type: REFERENCE_ASSETS.T,
        symbol: 'T',
        coingeckoId: 'threshold-network-token',
        decimals: 1e18,
        address: '0xCdF7028ceAB81fA0C6971208e83fa7872994beE5',
    },
    ustw: {
        id: 'ustw',
        type: REFERENCE_ASSETS.USD,
        symbol: 'UST',
        decimals: 1e6,
        address: '0xa693B19d2931d498c5B318dF961919BB4aee87a5',
    },
};
